import { AuthResult } from '../models/authResult';
import { UserAgentApplication, AuthResponse } from 'msal';
import { AppConfig } from '@/app-config';
import { MsalResult } from '@/enums';
import { Consts } from '@/consts';

export class AuthUtils {
	public static async authenticatePopup(userAgentApplication: UserAgentApplication): Promise<AuthResult> {
		let result: AuthResult = new AuthResult();
		try {
			if (userAgentApplication === undefined) {
				result.result = MsalResult.ParameterError;
				return result;
			}
			try {
				const loginPopupResponse = await userAgentApplication.loginPopup(AppConfig.AUTH_PARAMETERS);
				if (loginPopupResponse === null) {
					result.result = MsalResult.AuthResponseNullError;
					return result;
				}
				if (userAgentApplication.getAccount() === null) {
					result.result = MsalResult.AccountError;
					return result;
				}
				result = await AuthUtils.acquireTokenSilent(userAgentApplication);
				if (result.result !== MsalResult.InteractionRequiredError) {
					return result;
				}
				try {
					const acquireTokenPopupResponse = await userAgentApplication.acquireTokenPopup(AppConfig.AUTH_PARAMETERS);
					if (acquireTokenPopupResponse === null) {
						result.result = MsalResult.AuthResponseNullError;
						return result;
					}
					if ((acquireTokenPopupResponse.accessToken === null)
						|| (acquireTokenPopupResponse.accessToken === Consts.EMPTY_STRING)) {
						result.result = MsalResult.AccessTokenNullError;
						return result;
					}
					result.authResponse = acquireTokenPopupResponse;
					result.result = MsalResult.Success;
					return result;
				} catch (e) {
					result.result = MsalResult.AcquireTokenPopupError;
					return result;
				}
			} catch (e) {
				result.result = MsalResult.LoginPopupError;
				return result;
			}
		} catch (e) {
			console.error(e);
			result.result = MsalResult.UnknownError;
			return result;
		}
	}

	public static async acquireTokenSilent(userAgentApplication: UserAgentApplication): Promise<AuthResult> {
		const result: AuthResult = new AuthResult();
		try {
			if (userAgentApplication === undefined) {
				result.result = MsalResult.ParameterError;
				return result;
			}
			try {
				const authResponse: AuthResponse = await userAgentApplication.acquireTokenSilent(AppConfig.AUTH_PARAMETERS);
				if (authResponse === null) {
					result.result = MsalResult.AuthResponseNullError;
					return result;
				}
				if ((authResponse.accessToken === null) || (authResponse.accessToken === Consts.EMPTY_STRING)) {
					result.result = MsalResult.AccessTokenNullError;
					return result;
				}
				result.authResponse = authResponse;
				result.result = MsalResult.Success;
				return result;
			} catch (e) {
				if (e.name !== 'InteractionRequiredAuthError') {
					result.result = MsalResult.AcquireTokenSilentError;
					return result;
				}
				result.result = MsalResult.InteractionRequiredError;
				return result;
			}
		} catch (e) {
			console.error(e);
			result.result = MsalResult.UnknownError;
			return result;
		}
	}

	public static async authenticateRedirect(userAgentApplication: UserAgentApplication): Promise<AuthResult> {
		const result: AuthResult = new AuthResult();
		try {
			if (userAgentApplication === undefined) {
				result.result = MsalResult.ParameterError;
				return result;
			}
			userAgentApplication.loginRedirect(AppConfig.AUTH_PARAMETERS);
			result.result = MsalResult.RedirectingToLogin;
			return result;
		} catch (e) {
			console.error(e);
			result.result = MsalResult.UnknownError;
			return result;
		}
	}
}
